import vass from '@/common.less';
import CommonDrawer from '@/components/common/CommonDrawer';
import CommonEmpty from '@/components/common/CommonEmpty';
import useI18n from '@/hooks/useI18n';
import memberCommon from '@/pages/MemberMgr/memberCommon';
import {
  queryNumberForBundleService,
  querySelectNumberService,
} from '@/pages/MemberMgr/services';
import { EllipsisOutlined, ReloadOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { useRequest } from 'ahooks';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';

const { customPrimaryColor } = vass;

interface msisdnProps {
  servType?: number[];
  model?: string;
  offers?: any;
  value?: any;
  onChange?: (value: any) => void;
  bundleExtraParams?: any;
  disabled?: boolean;
  isneedShowGrade?: boolean;
}

const SelectMsisdn = (
  {
    servType,
    model,
    offers,
    value = {},
    bundleExtraParams,
    onChange,
    disabled,
    isneedShowGrade = false,
  }: msisdnProps,
  ref: any,
) => {
  const { selectedRows = [], gradeList = [] } = useModel(
    'MemberMgr.memberModel',
  );
  const { flowData } = useModel('MemberMgr.bundleModel');

  const { selectAddressParams = {} } = flowData;
  const {
    reservationId,
    custOrderId,
    serviceId,
    // resourceInstId,
    siteNameExchange,
  } = selectAddressParams;
  const { formatMessage } = useI18n();
  const [selectedMsisdn, setSelectedMsisdn] = useState<any>({}); // 选中的member号码
  const [inputValue, setInputValue] = useState<any>({});
  const [selectType, setSelectType] = useState<string>('Fuzzy');
  const [form] = Form.useForm();
  const drawerRef: any = useRef();
  const { useGrade, isneedCheckMsisdn } = memberCommon;
  const { queryGrade } = useGrade();

  const servTypes = servType
    ? servType
    : model === 'bundle'
      ? [80]
      : selectedRows.map((el: { servType: any }) => el?.servType || '');
  const offerIds = offers
    ? offers
    : selectedRows.map(
        (el: { subsPlan: { offerId: any } }) => el?.subsPlan?.offerId || '',
      );
  const bundleParams = bundleExtraParams
    ? bundleExtraParams
    : model === 'bundle'
      ? {
          exchangeCode: siteNameExchange,
          refOrderNbr: custOrderId,
          attrList: [
            {
              attrCode: 'reservationId',
              attrValue: reservationId,
            },
            {
              attrCode: 'serviceId',
              attrValue: serviceId || '',
            },
            {
              attrCode: 'exchangeCode',
              attrValue: siteNameExchange || '',
            },
          ],
        }
      : {};
  const service =
    selectedRows[0]?.servType === 51
      ? queryNumberForBundleService
      : querySelectNumberService;
  const {
    data = [],
    loading,
    runAsync: querySelectNumber,
    refresh,
  } = useRequest(service, {
    manual: true,
  });

  useImperativeHandle(ref, () => ({
    inputValue,
  }));

  const selectStyle = (record: { accNbr: string }) => {
    return record.accNbr === selectedMsisdn.accNbr
      ? {
          background: '#FFC8B3',
          boxShadow: '0px 4px 10px 0px rgba(112,158,250,0.2)',
          borderColor: customPrimaryColor,
          borderWidth: '3px',
        }
      : {
          borderColor: '#e0e0e0',
          borderWidth: '1px',
          backgroundColor: 'transparent',
        };
  };

  const onAutoSelect = async () => {
    const res = await querySelectNumber({
      autoFlag: true,
      offerIds,
      servTypes,
      prodIds: flowData?.prodId ? [flowData?.prodId] : undefined,
      bindingFlag: false,
      accNbrClassIds: isneedCheckMsisdn ? '130020,4' : undefined,
      oldAccNbr:
        isneedCheckMsisdn && model !== 'newConnection'
          ? selectedRows[0]?.msisdn
          : undefined,
      ...bundleParams,
    });
    setInputValue({
      newMsisdn: `${res[0]?.prefix || ''}${res[0]?.accNbr || ''}`,
      prefix: res[0]?.prefix || '',
      accNbr: res[0]?.accNbr || '',
    });
    onChange?.({
      newMsisdn: `${res[0]?.prefix || ''}${res[0]?.accNbr || ''}`,
      prefix: res[0]?.prefix || '',
      accNbr: res[0]?.accNbr || '',
    });
  };

  const onSelect = () => {
    drawerRef.current?.onClose();
    setInputValue({
      ...selectedMsisdn,
      newMsisdn: `${selectedMsisdn?.prefix || ''}${
        selectedMsisdn?.accNbr || ''
      }`,
    });
    onChange?.({
      ...selectedMsisdn,
      newMsisdn: `${selectedMsisdn?.prefix || ''}${
        selectedMsisdn?.accNbr || ''
      }`,
    });
  };

  const handleSearch = (val?: string) => {
    const formValue =
      model === 'bundle'
        ? {
            accNbrLike: selectType === 'Fuzzy' ? val?.slice(-4) : val,
          }
        : form.getFieldsValue();
    const offerIds = selectedRows.map(
      (el: { subsPlan: { offerId: any } }) => el?.subsPlan?.offerId || '',
    );
    // const servTypes = selectedRows.map((el) => el?.servType || '');
    querySelectNumber({
      servTypes,
      offerIds,
      prodIds: flowData?.prodId ? [flowData?.prodId] : undefined,
      beginIndex: 1,
      endIndex: 21,
      bindingFlag: false,
      oldAccNbr:
        isneedCheckMsisdn && model !== 'newConnection'
          ? selectedRows[0]?.msisdn
          : undefined,
      ...formValue,
      ...bundleParams,
      accNbrClassIds:
        isneedCheckMsisdn && !formValue.accNbrClassIds
          ? '130020,4'
          : formValue?.accNbrClassIds,
    });
  };

  const handleOpen = () => {
    drawerRef.current?.onOpen();
    const offerIds = selectedRows.map(
      (el: { subsPlan: { offerId: any } }) => el?.subsPlan?.offerId || '',
    );
    // const servTypes = selectedRows.map((el) => el?.servType || '');
    querySelectNumber({
      servTypes,
      offerIds,
      prodIds: [flowData?.prodId],
      beginIndex: 1,
      endIndex: 21,
      bindingFlag: false,
      accNbrClassIds: isneedCheckMsisdn ? '130020,4' : undefined,
      oldAccNbr:
        isneedCheckMsisdn && model !== 'newConnection'
          ? selectedRows[0]?.msisdn
          : undefined,
      ...bundleParams,
    });
  };

  useEffect(() => {
    queryGrade();
  }, []);

  const gradeSource = useMemo(() => {
    const list = gradeList.filter((item: any) =>
      ['C5', 'Normal'].includes(item.accNbrClassCode),
    );
    return [
      {
        accNbrClassCode: 'All',
        accNbrClassId: '130020,4',
        accNbrClassName: 'All',
        priority: 4,
      },
      ...list,
    ];
  }, [gradeList]);
  return (
    <>
      <Input
        readOnly
        addonAfter={
          <Space size={12}>
            <Button type="text" disabled={disabled || false}>
              <EllipsisOutlined onClick={handleOpen} />
            </Button>
            <Button type="text" disabled={disabled || false}>
              <ReloadOutlined onClick={onAutoSelect} />
            </Button>
          </Space>
        }
        value={value?.newMsisdn || inputValue?.newMsisdn}
        disabled={disabled || false}
      />
      <CommonDrawer
        width={820}
        title={formatMessage('memberMgr.selectServiceNumber')}
        ref={drawerRef}
        onOk={onSelect}
        beforeClose={() => form.resetFields()}
        destroyOnClose
      >
        <Spin spinning={loading} style={{ width: '100%' }}>
          <Form form={form} colon={false}>
            {model === 'bundle' ? (
              <Row style={{ marginBottom: 16 }}>
                <Col span={24}>
                  <Input.Search
                    onSearch={(val) => handleSearch(val)}
                    addonBefore={
                      <Select
                        defaultValue="Fuzzy"
                        onChange={(val) => {
                          setSelectType(val);
                        }}
                        style={{ minWidth: 200 }}
                      >
                        <Select.Option value="Fuzzy">
                          {formatMessage('memberMgr.last4FuzzySearch')}
                        </Select.Option>
                        <Select.Option value="Accurate">
                          {formatMessage('memberMgr.accurateSearch')}
                        </Select.Option>
                      </Select>
                    }
                  />
                </Col>
              </Row>
            ) : (
              <Row gutter={[12, 0]}>
                {(isneedCheckMsisdn || isneedShowGrade) && (
                  <>
                    <Col span={12}>
                      <Form.Item
                        label={formatMessage('memberMgr.numberGrade')}
                        name="accNbrClassIds"
                        style={{ marginBottom: 12 }}
                      >
                        <Radio.Group defaultValue="130020,4">
                          <Space size={20}>
                            {gradeSource.map((grade) => (
                              <Radio.Button
                                key={grade.accNbrClassId}
                                value={grade.accNbrClassId}
                                style={{
                                  width: '82px',
                                  borderRadius: '14px',
                                  textAlign: 'center',
                                }}
                              >
                                {grade.accNbrClassName}
                              </Radio.Button>
                            ))}
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col span={12}></Col>
                  </>
                )}
                <Col span={12}>
                  <Space>
                    <Form.Item
                      label={formatMessage('memberMgr.serviceNumber')}
                      name="accNbrStart"
                      style={{ marginBottom: 12 }}
                    >
                      <Input
                        style={{ width: 100 }}
                        allowClear
                        placeholder={formatMessage('memberMgr.form')}
                      />
                    </Form.Item>
                    <Form.Item
                      label="-"
                      name="accNbrEnd"
                      style={{ marginBottom: 12 }}
                    >
                      <Input
                        style={{ width: 100 }}
                        allowClear
                        placeholder={formatMessage('memberMgr.to')}
                      />
                    </Form.Item>
                  </Space>
                </Col>
                {/* <Col span={8}>
              </Col> */}
                <Col span={12}>
                  <Form.Item
                    style={{ marginBottom: 12 }}
                    label={formatMessage('memberMgr.keyNumber')}
                    name="accNbrLike"
                  >
                    <Input
                      // placeholder={formatMessage('memberMgr.keyword')}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ textAlign: 'right', marginBottom: 16 }}>
                  <Space>
                    <Button type="primary" onClick={() => handleSearch()}>
                      {formatMessage('form.query')}
                    </Button>
                    <Button
                      onClick={() => {
                        form.resetFields();
                      }}
                    >
                      {formatMessage('form.reset')}
                    </Button>
                  </Space>
                </Col>
              </Row>
            )}
          </Form>
          <Row gutter={[16, 12]}>
            {data.length ? (
              data.map((el: any) => (
                <Col span={8} key={el.accNbr}>
                  <Card
                    onClick={() => setSelectedMsisdn(el)}
                    style={{
                      ...selectStyle(el),
                      cursor: 'pointer',
                      width: '100%',
                      // borderRadius: '2px',
                    }}
                    bodyStyle={{ padding: 12 }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        marginBottom: 4,
                        color:
                          el.accNbr === selectedMsisdn.accNbr
                            ? customPrimaryColor
                            : '#2D3040',
                      }}
                    >{`${el?.prefix || ''}${el?.accNbr || ''}`}</div>
                    <div
                      style={{
                        color:
                          el.accNbr === selectedMsisdn.accNbr
                            ? customPrimaryColor
                            : '#575966',
                      }}
                    >
                      {el.accNbrClassName}
                    </div>
                  </Card>
                </Col>
              ))
            ) : (
              <CommonEmpty style={{ margin: 'auto' }} />
            )}
            <Col span={24} style={{ textAlign: 'center' }}>
              <Button
                // style={{ color: customPrimaryColor }}
                type="link"
                icon={<ReloadOutlined />}
                onClick={() => refresh()}
              >
                {formatMessage('memberMgr.changeNumbers')}
              </Button>
            </Col>
          </Row>
        </Spin>
      </CommonDrawer>
    </>
  );
};
export default forwardRef(SelectMsisdn);
